import { initialSiteGroupState, actions } from "./action";

export const siteGroupReducer = (state = initialSiteGroupState, action) => {
    switch (action.type) {
        case actions.SITEGROUP_GET_ALL_SUCCESS:
            return {
                ...state,
                siteGroupList:  action.payload ? action.payload : {}
            };
        case actions.SITEGROUP_UPDATE_SUCCESS:
            return {
                ...state,
                siteGroupDetails: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.SITEGROUP_CREATE_SUCCESS:
            return {
                ...state,
                siteGroupDetails: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.SITEGROUP_DELETE_SUCCESS:
            return {
                ...state,
                siteGroupDetails: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.SITEGROUP_RESET_SUCCESS:
            return {
                ...state,
                siteGroupDetails: {}
            };
        
        case actions.SITEGROUP_SYNCGROUP_SUCCESS:
            return {
                ...state,
                siteGroupSynced: action.payload
            };
        
        case actions.SITEGROUP_SYNCGROUP_FAILURE:
            return {
                ...state,
                siteGroupSynced: action.payload
            };
        case actions.SITEGROUP_SYNCGROUPRESET__SUCCESS:
        case actions.SITEGROUP_SYNCGROUPRESET__FAILURE:
            return {
                ...state,
                siteGroupSynced: {}
            };
        
        default:
            return state;
    }
};
